import { createContext } from 'react';

import type { IUsdWithdrawRequestContext } from '../../../DialogWithdrawRequest.helpers';

export const UsdWithdrawRequestContext = createContext<IUsdWithdrawRequestContext | null>(null);
